import { fetchJson } from "../lib/api";
import type { CostCenterType } from "./carts";

// Orders confirmed from a cart (#554, #555). Read-only: what was ordered is
// frozen at confirmation, later steps follow with the order confirmation.

export type PurchaseOrderStatus =
  | "ordered"
  | "confirmation_received"
  | "approved"
  | "query"
  | "rejected"
  | "invoiced"
  | "done";

export type PurchaseOrder = {
  order_id: string;
  reference: string;
  supplier: string | null;
  cost_center: { type: CostCenterType; key: string; label: string };
  delivery_address: string | null;
  status: PurchaseOrderStatus;
  status_label: string;
  total: string;
  total_complete: boolean;
  ordered_at: string;
  owner: { user_id: string; name: string; is_me: boolean };
  cart_id: string;
  line_count: number;
};

export type PurchaseOrderLine = {
  position: number;
  /** null for a special position (#556): it has no article. */
  article_group_key: string | null;
  article_code: string | null;
  description: string | null;
  qty: string;
  uom: string | null;
  unit_price: string | null;
  target_price: string | null;
  total: string | null;
  is_special: boolean;
};

export type PurchaseOrderDetail = PurchaseOrder & { lines: PurchaseOrderLine[] };

export const purchaseOrdersQueryKey = (scope: "mine" | "company", q: string) =>
  ["purchase-orders", "list", scope, q] as const;
export const purchaseOrderQueryKey = (orderId: string) => ["purchase-orders", "detail", orderId] as const;

export function fetchPurchaseOrders(scope: "mine" | "company", q = ""): Promise<{ items: PurchaseOrder[] }> {
  const params = new URLSearchParams({ scope });
  if (q.trim()) params.set("q", q.trim());
  return fetchJson<{ items: PurchaseOrder[] }>(`/api/purchase-orders?${params}`);
}

export const fetchPurchaseOrder = (orderId: string) =>
  fetchJson<PurchaseOrderDetail>(`/api/purchase-orders/${encodeURIComponent(orderId)}`);
